import { jsx } from 'react/jsx-runtime';
import { useEffect } from 'react';
import clsx from 'clsx';
import { VideoPlayer } from '../VideoPlayer/VideoPlayer.js';
import css from './BelongExplainerVideo.module.css.js';

const subtitlesSrc = '/home/belong-explainer-video-sub.vtt';
function BelongExplainerVideo({
  autoplay = true,
  wrapperClassName,
  playIconStyle = 'default',
  videoClassName,
  buttonWrapperClassName
}) {
  useEffect(() => {
    if (subtitlesSrc.slice(subtitlesSrc.length - 3) !== 'vtt') return; // check if the file is .vtt
    const track = document.getElementsByTagName('track')[0];
    if (!track || !(track instanceof TextTrack)) return;
    track.oncuechange = () => {
      if (track.activeCues && track.activeCues[0]) {
        track.activeCues[0].line = -2; // move the subtitles up one line (only works with .vtt files)
        track.activeCues[0].position = 50;
      }
    };
  }, []);
  return jsx("div", {
    className: clsx(css.video_container, wrapperClassName),
    children: jsx(VideoPlayer, {
      autoplay: autoplay,
      videoSrc: "https://belong-consumer-assets.s3.us-west-1.amazonaws.com/belong-explainer-video/belong_explainer.mp4",
      posterSrc: "/belong-explainer-video/belong_video_placeholder.jpg",
      playsInline: true,
      tracks: [jsx("track", {
        label: "English",
        kind: "subtitles",
        srcLang: "en",
        src: subtitlesSrc,
        default: true
      }, 0)],
      playIconStyle: playIconStyle,
      videoClassName: videoClassName,
      buttonWrapperClassName: buttonWrapperClassName
    })
  });
}

export { BelongExplainerVideo };
